import React from 'react';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import './AdherenceChart.css';

const AdherenceChart = ({ data }) => {
  // Create mock time series data for the chart
  const timeSeriesData = [
    { month: 'Mar', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage }), {}) },
    { month: 'Apr', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage + Math.random() * 10 - 5 }), {}) },
    { month: 'May', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage + Math.random() * 10 - 5 }), {}) },
    { month: 'Jun', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage + Math.random() * 10 - 5 }), {}) },
    { month: 'Jul', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage + Math.random() * 10 - 5 }), {}) },
    { month: 'Aug', ...data.reduce((acc, med) => ({ ...acc, [med.name]: med.percentage }), {}) }
  ];

  return (
    <div className="adherence-chart">
      <div className="medication-list">
        {data.map((medication, index) => (
          <div key={index} className="medication-item">
            <div className="medication-info">
              <div 
                className="medication-color" 
                style={{ backgroundColor: medication.color }}
              ></div>
              <span className="medication-name">{medication.name}</span>
            </div>
            <div className="medication-percentage">
              {medication.percentage}%
            </div>
          </div>
        ))}
      </div>
      
      <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={timeSeriesData}>
            <XAxis 
              dataKey="month" 
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#6b7280' }}
            />
            <YAxis 
              domain={[0, 100]}
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: '#6b7280' }}
              tickFormatter={(value) => `${value}%`}
            />
            {data.map((medication, index) => (
              <Line
                key={medication.name}
                type="monotone"
                dataKey={medication.name}
                stroke={medication.color}
                strokeWidth={2}
                dot={{ r: 4, fill: medication.color }}
                activeDot={{ r: 6, fill: medication.color }}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AdherenceChart;



